import { setBusinessAppointmentsAction } from 'shared/store/data/filters/actions';
import { setTargetOffersCountTooltip } from 'shared/store/data/offersCountTooltip/actions';
import { boundActionsFactory } from 'shared/utils/hooks/useBoundActions';

export const useBusinessAppointmentsFilterBoundActions = boundActionsFactory({
  setBusinessAppointmentsAction,
  setTargetOffersCountTooltip,
});
